import {
  ChangeDetectionStrategy, Component, Input, ViewEncapsulation, inject,
} from '@angular/core'
import { Icon } from '@knorr-bremse-portals/icons'
import { IconService } from './icon.service'

@Component({
  selector: 'kb-icon, button[kb-icon], a[kb-icon]',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  encapsulation: ViewEncapsulation.None,
})
export class IconComponent {
  private _icon!: Icon
  @Input() public set icon(icon: Icon) {
    this._icon = icon
    this.updateIcon()
  }

  public get icon(): Icon {
    return this._icon
  }

  protected href!: string

  private iconService = inject(IconService)

  private updateIcon() {
    const id = this.iconService.registerIcon(this.icon.name, this.icon.data)
    this.href = `#${id}`
  }
}
